package input

import com.soywiz.korge.view.*
import ui.*

/**
 * Common interface for different controllers (touch, keyboard, gamepad etc)
 */
interface InputController {

    val left: KeyState
    val right: KeyState
    val down: KeyState

    val jump: KeyState

    val firstAbility: KeyState
    val secondAbility: KeyState

    val dash: KeyState
}

data class InputControllerData(
    val controller: InputController,
    val stick: View?,
    val jumpButton: CustomButton?,
    val firstAbilityButton: AbilityButton,
    val secondAbilityButton: AbilityButton,
    val dashButton: CustomButton? = null,
    val leftArrow: CustomButton? = null,
    val rightArrow: CustomButton? = null
)

